import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { useEffect, useState } from 'react'
import { CheckBox } from 'react-native-elements'

const MeInformationForm = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const { loading, postmeonline, getmodetails } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()

    const intialValues = {
        martialStatus: "",
        additionalwithholding: "",
        stateIncomeTaxWithheld: "",
        exemptionForYourself: "",
        exemptionForSpouse: "",
        exemptionForHeadOfHousehold: "",
        noOfDependents: "",
        tribalMemberExemption: 0

    }

    const options1 = [
        { key: 1, value: 'Single or Head of Household' },
        { key: 2, value: 'Married' },
        { key: 3, value: 'Married, but withholding at higher single rate' }
    ]




    const paschema = yup.object({
        martialStatus: yup.string().required("Martial status is a required field"),
        additionalwithholding: yup.string().nullable(),
        stateIncomeTaxWithheld: yup.mixed().nullable(),
        exemptionForYourself: yup
            .string()
            .matches(/^1$/, "Enter '1' or leave it empty")
            .nullable(),
        exemptionForSpouse: yup
            .string()
            .matches(/^[01]$/, "Enter '0', '1', or leave it empty")
            .nullable(),
        exemptionForHeadOfHousehold: yup
            .string()
            .matches(/^1$/, "Enter '1' or leave it empty")
            .nullable(),
        noOfDependents: yup.string().nullable(),
        tribalMemberExemption: yup.number().nullable()

    })


    const checkboxData = [
        {
            id: 1,
            title: 'You wrote “Exempt” on your federal Form W-4',
            isChecked: false,
            option: 'a'
        },
        {
            id: 2,
            title: 'You wrote “No Withholding” on your federal Form W-4P',
            isChecked: false,
            option: 'b'
        },
        {
            id: 3,
            title:
                'You are a resident employee with no Maine tax liability in prior and current years',
            isChecked: false,
            option: 'c'
        },
        {
            id: 4,
            title:
                'You are a recipient of periodic retirement payments with no tax liability in prior and current years',
            isChecked: false,
            option: 'd'
        },
        {
            id: 5,
            title:
                'Your spouse is a member of the military assigned to a location in Maine and you qualify for exemption under the Military Spouse’s Residency Relief Act.You must attach supporting documents.',
            isChecked: false,
            option: 'e'
        }
    ]
    const [checkboxes, setCheckboxes] = useState(checkboxData);

    const toggleCheckbox = (id: any) => {
        const newCheckboxes = checkboxes.map(checkbox =>
            checkbox.id === id ? { ...checkbox, isChecked: !checkbox.isChecked } : checkbox
        );
        setCheckboxes(newCheckboxes);
    };


    const getCheckedIds = () => {
        return checkboxes
            .filter((checkbox) => checkbox.isChecked)
            .map((checkbox) => checkbox.option)
    }




    useEffect(() => {
        getmodetails(initializestore?.initializeData?.userkey)
    }, [])


    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'ME Withholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={paschema}
                    onSubmit={async (values, actions) => {

                        const ids = getCheckedIds()
                        const total = Number(values?.exemptionForYourself) + Number(values?.exemptionForSpouse) + Number(values?.exemptionForHeadOfHousehold) + Number(values?.noOfDependents)
                        const data = {
                            entityId: personalstore?.personalData?.entityId,
                            essUserKey: initializestore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            completeOnline: mode === 'upload' ? false : true,
                            maritalStatus: values?.martialStatus,
                            additionalAmount: Number(values?.additionalwithholding),
                            stateIncomeTaxWithheld: ids,
                            exemptionForYourself: Number(values?.exemptionForYourself),
                            exemptionForSpouse: Number(values?.exemptionForSpouse),
                            exemptionForHeadOfHousehold: Number(values?.exemptionForHeadOfHousehold),
                            noOfDependents: Number(values?.noOfDependents),
                            totalAllowances:
                                Number(values?.exemptionForYourself) +
                                Number(values?.exemptionForSpouse) +
                                Number(values?.exemptionForHeadOfHousehold) +
                                Number(values?.noOfDependents),
                            tribalMemberExemption: values?.tribalMemberExemption ? 1 : 0
                        }

                        console.log("data", data);

                        const response = await postmeonline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('MeInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,
                                    ids,
                                    total
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }

                    }}
                >
                    {(props) => (
                        <>
                            <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Martial status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Martial status"
                                            options={options1}
                                            selectedOption={props.values.martialStatus === 0 ? 'Single or Head of Household' :
                                                props.values.martialStatus === 1 ? 'Married' :
                                                    props.values.martialStatus === 2 ? 'Married, but withholding at higher single rate' : ''}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('martialStatus', option - 1)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.martialStatus &&
                                            props.errors.martialStatus && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.martialStatus}
                                                </Text>
                                            )}
                                    </View>
                                </View>


                                {!(checkboxes.some(c => c.isChecked) || props.values.tribalMemberExemption === 1) && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Additional amount, if any, you want withheld from your paycheck '}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.additionalwithholding}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('additionalwithholding')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.additionalwithholding && props.errors.additionalwithholding && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.additionalwithholding}
                                                </Text>
                                            )}
                                        </View>
                                    </View>
                                )}



                                <View
                                    style={[
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'If you do not want any state income tax withheld, check the appropriate box that applies to you'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                                        {checkboxes.map(checkbox => (
                                            <CheckBox
                                                key={checkbox.id}
                                                title={checkbox.title}
                                                checked={checkbox.isChecked}
                                                onPress={() => {
                                                    toggleCheckbox(checkbox.id)
                                                    const updatedCheckboxes = checkboxes.map(c =>
                                                        c.id === checkbox.id ? { ...c, isChecked: !c.isChecked } : c
                                                    )
                                                    const anyChecked = updatedCheckboxes.some(c => c.isChecked)
                                                    const newCheckedOptions = updatedCheckboxes
                                                        .filter(c => c.isChecked)
                                                        .map(c => c.option)
                                                    props.setFieldValue("stateIncomeTaxWithheld", newCheckedOptions)
                                                    if (anyChecked) {
                                                        props.setFieldValue("additionalwithholding", "")
                                                    }
                                                }}
                                                checkedColor="#0B495C"
                                                uncheckedColor="#0B495C"
                                                containerStyle={{ backgroundColor: 'transparent', borderWidth: 0, width: '100%' }}
                                                titleProps={{
                                                    style: {
                                                        fontWeight: "normal",
                                                        color: "#0B495C",
                                                        flex: 1,
                                                    }
                                                }}
                                            />
                                        ))}
                                    </View>
                                    {props.touched.stateIncomeTaxWithheld &&
                                        props.errors.stateIncomeTaxWithheld && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.stateIncomeTaxWithheld as string}
                                            </Text>
                                        )}
                                </View>



                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '70%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter “1” for yourself if no one else can claim you as a dependent'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.exemptionForYourself}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('exemptionForYourself')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.exemptionForYourself && props.errors.exemptionForYourself && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.exemptionForYourself as string}
                                            </Text>
                                        )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '70%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter “1” for your spouse if you will file as married filing jointly. You may choose to enter “0” if you are married and have either a working spouse or more than one job.'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.exemptionForSpouse}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('exemptionForSpouse')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.exemptionForSpouse && props.errors.exemptionForSpouse && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.exemptionForSpouse as string}
                                            </Text>
                                        )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '70%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter “1” if you will be filing as Head of Household'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.exemptionForHeadOfHousehold}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('exemptionForHeadOfHousehold')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.exemptionForHeadOfHousehold && props.errors.exemptionForHeadOfHousehold && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.exemptionForHeadOfHousehold as string}
                                            </Text>
                                        )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '70%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter the number of children and dependents eligible for the federal child tax credit or the federal credit for other dependents'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.noOfDependents}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('noOfDependents')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.noOfDependents && props.errors.noOfDependents && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.noOfDependents as string}
                                            </Text>
                                        )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '75%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Check this box if you are an enrolled tribal member residing on tribal land in Maine and you are claiming an exemption from Maine withholding on the wages, salaries, or other compensation derived from or connected with sources on tribal land in Maine (that is, wages, salaries, or other compensation for work performed in Maine on tribal land).'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '20%', alignItems: 'flex-end', justifyContent: 'center' }}>
                                        <CheckBox
                                            checked={props.values.tribalMemberExemption === 1}
                                            onPress={() => {
                                                const newVal = props.values.tribalMemberExemption === 1 ? 0 : 1
                                                props.setFieldValue("tribalMemberExemption", newVal)
                                                if (newVal === 1) {
                                                    props.setFieldValue("additionalwithholding", "")
                                                }
                                            }}
                                            checkedColor="#0B495C"
                                            uncheckedColor="#0B495C"
                                            containerStyle={{ backgroundColor: 'transparent', borderWidth: 0, padding: 0, margin: 0 }}
                                        />
                                    </View>
                                </View>



                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}

                            </Card>
                        </>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default MeInformationForm
